import { render, staticRenderFns } from "./ParticipantDocuments.vue?vue&type=template&id=9b2e1b60&"
import script from "./ParticipantDocuments.vue?vue&type=script&lang=js&"
export * from "./ParticipantDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports